/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import {FETCH_PCS_LOGS_SUCCESS} from "../_actions/pcs.logs.actions";

export const INITIAL_STATE = [];

export function pcsLogsReducer (state = INITIAL_STATE, action) {
    switch (action.type) {
        case FETCH_PCS_LOGS_SUCCESS: {
            return action.payload;
        }
        default: {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/pcs.logs.reducer.js